import { createContext, ReactNode, useContext } from "react";

import { useFilterUtilActivityType } from "./filter-util-activity-type.hook";

const FilterUtilActivityTypeContext = createContext(
  {} as ReturnType<typeof useFilterUtilActivityType>
);
export function useFilterUtilActivityTypeContext() {
  return useContext(FilterUtilActivityTypeContext);
}

interface FilterUtilActivityTypeProviderProps {
  children: ReactNode;
}
export function FilterUtilActivityTypeProvider({
  children,
}: FilterUtilActivityTypeProviderProps) {
  return (
    <FilterUtilActivityTypeContext.Provider value={useFilterUtilActivityType()}>
      {children}
    </FilterUtilActivityTypeContext.Provider>
  );
}